import BrButton from '@govbr/react-components/lib/BrButton';
import { useHistory } from 'react-router-dom';
import { useAppSelector } from '../../../app/hooks';
import erroIndicativoNascimento from '../../../assets/img/erro-indicativo-nascimento.png';
import { selectIntegranteIndicativoNascimento } from '../indicativoNascimentoSlice';
import { mostrarPostosAtendimento } from '../../Home/Home';
import styles from './IndicativoNascimentoErro.module.css';

interface Props {
  onFechar: () => void;
}

const IndicativoNascimentoErro: React.FC<Props> = ({ onFechar }) => {
  const history = useHistory();
  const integrante = useAppSelector(selectIntegranteIndicativoNascimento);
  const nomeCompleto = integrante?.nome?.toUpperCase() ?? '';

  return (
    <div className={styles.container}>
      <div className={styles.imagemWrapper}>
        <img
          className={styles.imagem}
          src={erroIndicativoNascimento}
          alt="Erro ao incluir integrante"
        />
      </div>
      <div className={styles.conteudo}>
        <p className={styles.textoPrincipal}>
          Não foi possível incluir o {nomeCompleto} no cadastro da sua família.
        </p>
        <p className={styles.textoSecundario}>
          Compareça ao CRAS ou posto de atendimento do Cadastro Único para atualizar o cadastro de sua família.
        </p>
        <p className={styles.textoPostos}>
          Você pode buscar onde ficam os postos de atendimento mais próximos de você na opção{' '}
          <span className={styles.link} onClick={() => mostrarPostosAtendimento(history)}>
            Postos de Atendimento
          </span>
          .
        </p>
        <BrButton className={styles.botaoFechar} onClick={onFechar}>
          Fechar
        </BrButton>
      </div>
    </div>
  );
};

export default IndicativoNascimentoErro;
